import Recipe from './Recipe';

export const recipeRoutes = [{path: '/recipe/:id', name: 'Recipe', Component: Recipe}];
